import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import useReduxPopupSystem from 'src/new_arch/hooks/useReduxPopupSystem';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import { deleteProjects } from 'src/actions/projects';
import Project from 'src/entities/workspaceProject';

const useDeleteWorkspaceProject = ( { project }: { project: Project } ) => {
	const dispatch = useDispatch();
	const popupSystem = useReduxPopupSystem();
	const snackbarSystem = useSnackbarSystem();

	const onDeleteProjectClick = useCallback( () => {
		popupSystem.showDangerConfirmationDialog( {
			title: 'Delete Project',
			description: `Are you sure you want to delete ${project.name} project\nfor all members? You won't be able to recover it.`,
			checkboxDescription: 'I understand that I will lose all content and information related to this project',
			acceptText: 'Yes, delete',
			cancelText: 'Cancel',
			descriptionAlignment: 'left'
		} )
			.then( ( confirm: boolean ) => {
				if ( confirm ) {
					( dispatch( deleteProjects( [ project.id ] ) ) as unknown as Promise<void> ).then(
						() => snackbarSystem.showSuccessMessage( {
							title: 'The project was successfully deleted.'
						} )
					);
				}
				popupSystem.hideConfirmationDialog();
			} );
	}, [ project.id, project.name, popupSystem ] );

	return onDeleteProjectClick;
}

export default useDeleteWorkspaceProject;
